import { jwtDecode } from 'jwt-decode';

const TokenService = {
  setToken: (newToken) => {
    localStorage.setItem('Token', newToken);
  },
  getToken: () => {
    const token = localStorage.getItem('Token');
    if (!token || TokenService.isTokenExpired(token)) return null;
    return token;
  },
  clearToken: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('Token');
    localStorage.removeItem('iissms_login_email');
  },
  isTokenExpired: (token) => {
    try {
      const decoded = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp <= now;
    } catch {
      return true;
    }
  },
};

export default TokenService;

